import { z } from 'zod';
export const mailAddressSchema = z.string().trim().max(254).email('Проверьте адрес электронной почты');
export function splitMailAddresses(value) {
    return [...new Set(value.split(/[,;\s]+/).map(s => s.trim().toLowerCase()).filter(Boolean))];
}
export const mailRecipientsSchema = z.string().max(6000).transform(splitMailAddresses)
    .pipe(z.array(mailAddressSchema).min(1, 'Укажите почту получателя').max(20, 'Не более 20 адресов'))
    .transform(addresses => addresses.join(', '));
//# sourceMappingURL=mail.js.map